import { LabelWithTipProps } from '@/components/LabelWithTip';
import { useState } from 'react';

const useTabs = <T>(data: { key: T; label?: string | React.ReactElement; url?: string; tips?: LabelWithTipProps }[]) => {
  const [tabs, setTabs] = useState(data);
  const [activeTab, setActiveTab] = useState(data.length ? data[0].key : null);

  return {
    tabs,
    setTabs,
    activeTab,
    onChangeTab: setActiveTab,
  };
};

export default useTabs;
